import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import { getEnumMap, isEmptyOrWhiteSpace } from "@/utils/Common";
import { showConfirm, showSuccess, showWarning } from "@/utils/UI";
import { API_BIS_CUSTOMFIELD } from "@/configs/Apis";
import { useStore } from "@/stores";
import DuduAjax from "@/utils/DuduAjax";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomField',
  emits: ["field-changed"],
  setup(__props, { expose, emit }) {



const store = useStore();

const visible = ref(false);

const dataForm = ref<any>(null);

const addMetaDataVisible = ref(false);

const metadataItem = ref({ fieldType: "VARCHAR", label: "", enumValues: "", id: "" });

const changed = ref(false);

const metaDataItems = computed(() => (store.state as any).project.metadata);

const isEdit = computed(() => !isEmptyOrWhiteSpace(metadataItem.value.id));

const validateRules = computed(() => ({
  label: [{ required: true, message: "请输入字段名称", trigger: "blur" }],
  enumValues: [
    {
      validator: (rule: any, value: any, callback: any) => {
        if (metadataItem.value.fieldType === "ENUM" && isEmptyOrWhiteSpace(metadataItem.value.enumValues)) {
          callback(new Error("请输入下拉框中的值"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
}));

const projectId = computed(() => {
  const pInfo: any = (store.state as any).project.info || {};
  return pInfo.id || 0;
});

const formatFieldType = (data: any, col: any, value: any) => {
  const map = getEnumMap(store.getters["enums/getEnumsByKey"]("FieldType"));
  return map.get(value);
};

const addMetaData = () => {
  if (metaDataItems.value && metaDataItems.value.length >= 24) {
    showWarning("标引字段最多添加24个");
    return;
  }
  addMetaDataVisible.value = true;
};

const saveMetaData = () => {
  dataForm.value.validate((isValid: boolean) => {
    if (!isValid) {
      return;
    }

    const requestPath: any = { projectId: projectId.value };
    if (!isEmptyOrWhiteSpace(metadataItem.value.id)) {
      requestPath.id = metadataItem.value.id;
    }
    const postedData: any = {
      label: metadataItem.value.label,
      enumValues: metadataItem.value.enumValues,
    };
    if (!isEmptyOrWhiteSpace(metadataItem.value.id)) {
      postedData.id = metadataItem.value.id;
    } else {
      postedData.fieldType = metadataItem.value.fieldType;
    }
    (Object.prototype.hasOwnProperty.call(postedData, "id") ? DuduAjax.put : DuduAjax.post)
      .call(DuduAjax, { url: API_BIS_CUSTOMFIELD, path: requestPath }, postedData)
      .then(() => {
        showSuccess("保存成功");
        store.dispatch("project/setCustomField", (store.state as any).project.info);
        addMetaDataVisible.value = false;
        changed.value = true;
      });
  });
};

const deleteMataData = (field: any) => {
  showConfirm("是否删除这个标引字段").then(() => {
    DuduAjax.delete({ url: API_BIS_CUSTOMFIELD, path: { projectId: projectId.value, id: field.id } }, field.id).then(
      () => {
        showSuccess("删除成功");
        store.dispatch("project/setCustomField", (store.state as any).project.info);
        changed.value = true;
      }
    );
  });
};

const editMataData = (field: any) => {
  metadataItem.value = Object.assign(
    { fieldType: "VARCHAR", label: "", enumValues: "" },
    JSON.parse(JSON.stringify(field))
  );
  addMetaDataVisible.value = true;
};

const closeMetaDataDialog = () => {
  addMetaDataVisible.value = false;
  metadataItem.value = { fieldType: "VARCHAR", label: "", enumValues: "", id: "" };
};

const closeDialog = () => {
  visible.value = false;
  if (changed.value) {
    emit("field-changed");
  }
};

const open = () => {
  changed.value = false;
  addMetaDataVisible.value = false;
  visible.value = true;
};

expose({ open });

watch(
  () => metadataItem.value.fieldType,
  () => {
    if (metadataItem.value.fieldType !== "ENUM") {
      metadataItem.value.enumValues = "";
    }
  }
);

watch(addMetaDataVisible, () => {
  if (!addMetaDataVisible.value) {
    metadataItem.value = { fieldType: "VARCHAR", label: "", enumValues: "", id: "" };
  }
});

return { __sfc: true,emit, store, visible, dataForm, addMetaDataVisible, metadataItem, changed, metaDataItems, isEdit, validateRules, projectId, formatFieldType, addMetaData, saveMetaData, deleteMataData, editMataData, closeMetaDataDialog, closeDialog, open }
}

})